"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateLandingPage = exports.debounceFetchedByNameQueryEpic = exports.fetchByLanguageContentEpic = exports.fetchedByIdsEpic = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _switchMap = require("rxjs/operators/switchMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _debounceTime = require("rxjs/operators/debounceTime");

var _distinctUntilChanged = require("rxjs/operators/distinctUntilChanged");

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetch = function fetch(apiCall, actionTypes) {
  return function (action) {
    return (0, _fromPromise.fromPromise)(apiCall(action.payload)).pipe((0, _map.map)(function (response) {
      return actionTypes.success(response, action.payload);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(actionTypes.failure(error, action.payload));
    }), (0, _startWith.startWith)(actionTypes.request(action.payload)));
  };
};

var fetchByIds = fetch(_API.default.getByIds, _actions.FetchLandingPagesByIds);
var fetchByNameQuery = fetch(_API.default.getByNameQuery, _actions.FetchLandingPagesByNameQuery);
var fetchByLanguageContent = fetch(_API.default.getByLanguageContent, _actions.FetchLandingPagesByLanguageContent);

var fetchedByIdsEpic = function fetchedByIdsEpic($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_IDS).pipe((0, _filter.filter)(function (action) {
    var status = (0, _selectors.getLandingPagesByIdsRequestStatus)(action.payload.ids)(getState());
    return _RequestStatusTypeFilters.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(fetchByIds));
};

exports.fetchedByIdsEpic = fetchedByIdsEpic;

var fetchByLanguageContentEpic = function fetchByLanguageContentEpic($action) {
  return $action.ofType(_actions.LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_LANGUAGE_CONTENT).pipe((0, _mergeMap.mergeMap)(fetchByLanguageContent));
};

exports.fetchByLanguageContentEpic = fetchByLanguageContentEpic;

var debounceFetchedByNameQueryEpic = function debounceFetchedByNameQueryEpic($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions.LandingPagesActionTypes.DEBOUNCED_FETCH_LANDING_PAGES_BY_NAME_QUERY).pipe((0, _debounceTime.debounceTime)(750), (0, _distinctUntilChanged.distinctUntilChanged)(), (0, _filter.filter)(function (action) {
    var status = (0, _selectors.getLandingPagesByNameQueryRequestStatus)(action.payload.nameQuery)(getState());
    return _RequestStatusTypeFilters.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _switchMap.switchMap)(fetchByNameQuery));
};

exports.debounceFetchedByNameQueryEpic = debounceFetchedByNameQueryEpic;
var updateLandingPage = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateLandingPage,
  initiatingActionType: _actions.LandingPagesActionTypes.UPDATE_LANDING_PAGE,
  requestStatusSelector: _selectors.getUpdateLandingPagesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateLandingPage
}));
exports.updateLandingPage = updateLandingPage;

var _default = (0, _reduxObservable.combineEpics)(debounceFetchedByNameQueryEpic, fetchedByIdsEpic, fetchByLanguageContentEpic, updateLandingPage);

exports.default = _default;